import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CreateCustomerDto, Customer } from '../../models/customer';
import { Page } from '../../models/page';

@Injectable({
  providedIn: 'root',
})
export class CustomersHttpService {
  private static readonly baseurl = environment.baseurl;
  private readonly httpClient = inject(HttpClient);

  getAllCustomers(params: { name: string; page: number; size: number }) {
    return this.httpClient.get<Page<Customer>>(`${CustomersHttpService.baseurl}/api/customers`, {
      params,
    });
  }

  getCustomerById(id: string) {
    return this.httpClient.get<Customer>(`${CustomersHttpService.baseurl}/api/customers/${id}`);
  }

  /** Searches name, address and phone. Scoped server-side: a rep only sees their own. */
  searchCustomers(query: string) {
    return this.httpClient.get<Customer[]>(`${CustomersHttpService.baseurl}/api/customers/search`, {
      params: { query },
    });
  }

  getCustomersByRep(repId: string) {
    return this.httpClient.get<Customer[]>(
      `${CustomersHttpService.baseurl}/api/customers/by-rep/${repId}`,
    );
  }

  createCustomer(customer: CreateCustomerDto) {
    return this.httpClient.post<Customer>(
      `${CustomersHttpService.baseurl}/api/customers`,
      customer,
    );
  }

  createCustomers(customers: CreateCustomerDto[]) {
    return this.httpClient.post<Customer[]>(
      `${CustomersHttpService.baseurl}/api/customers/many`,
      customers,
    );
  }

  updateCustomer(customer: Customer) {
    return this.httpClient.patch<Customer | null>(
      `${CustomersHttpService.baseurl}/api/customers`,
      customer,
    );
  }

  deleteCustomer(id: string) {
    return this.httpClient.delete<Customer | null>(
      `${CustomersHttpService.baseurl}/api/customers/${id}`,
    );
  }
}
